import { JobShiftsQuickFilters } from '@th-types/jobs.type';

export enum JobListQuickFiltersMobile {
  MEMBER_JOBS = 'My Jobs',
  MEMBER_HIDDEN_JOBS = 'My hidden jobs',
  MEMBER_PAST_JOBS = 'My past jobs',
  COMPANY_JOBS = 'Company jobs',
  COMPANY_HIDDEN_JOBS = 'Company hidden jobs',
  COMPANY_PAST_JOBS = 'Company past jobs',
}

export const memberJobs = {
  value: JobListQuickFiltersMobile.MEMBER_JOBS,
  label: 'My jobs',
};

export const memberHiddenJobs = {
  value: JobListQuickFiltersMobile.MEMBER_HIDDEN_JOBS,
  label: 'My hidden jobs',
};

export const memberPastJobs = {
  value: JobListQuickFiltersMobile.MEMBER_PAST_JOBS,
  label: 'My past jobs',
};

export const companyJobs = {
  value: JobListQuickFiltersMobile.COMPANY_JOBS,
  label: 'Company jobs',
};

export const companyHiddenJobs = {
  value: JobListQuickFiltersMobile.COMPANY_HIDDEN_JOBS,
  label: 'Company hidden jobs',
};

export const companyPastJobs = {
  value: JobListQuickFiltersMobile.COMPANY_PAST_JOBS,
  label: 'Company past jobs',
};

export const jobListQuickFilterActions = [
  memberJobs,
  memberHiddenJobs,
  memberPastJobs,
  companyJobs,
  companyHiddenJobs,
  companyPastJobs,
];

export type JobShiftsQuickFilterOption = {
  value: JobShiftsQuickFilters | undefined;
  label: string;
};

export const jobShiftsQuickFilterActions: JobShiftsQuickFilterOption[] = [
  {
    value: JobShiftsQuickFilters.TO_APPROVE,
    label: 'To Approve',
  },
  {
    value: JobShiftsQuickFilters.MARK_PAID,
    label: 'Mark Paid',
  },
  {
    value: JobShiftsQuickFilters.MISSING_HOURS,
    label: 'Missing Hours',
  },
  {
    value: JobShiftsQuickFilters.NO_CHECK_IN_OUT,
    label: 'No Check In/Out',
  },
  {
    value: JobShiftsQuickFilters.ONBOARDING,
    label: 'Onboarding',
  },
  {
    value: JobShiftsQuickFilters.CURRENT_OPEN_SHIFTS,
    label: 'Current Open Shifts',
  },
];
